$('form.cart').on('click', 'button.plus, button.minus', function () {
  var qty = $(this).closest('form.cart').find('.qty');
  var val = parseFloat(qty.val());
  var max = parseFloat(qty.attr('max'));
  var min = parseFloat(qty.attr('min'));
  var step = parseFloat(qty.attr('step'));
  if ($(this).is('.plus')) {
    if (max && (max <= val)) {
      qty.val(max);
    } else {
      qty.val(val + step);
    }
  } else {
    if (min && (min >= val)) {
      qty.val(min);
    } else if (val > 1) {
      qty.val(val - step);
    }
  }
  qty.trigger('change');
  handleValidation();
});

/** Add message to page */
$('<p class="error-message" style="color: red; display: none;">Please fill out all fields</p>').insertAfter($('.product_cat-events form .wc-box-office-ticket-form'));

function validateInputs($inputs, $submit, $message) {
  const empty = $inputs.filter(function () {
    return this.value === '';
  });

  if (empty.length) {
    $submit.prop('disabled', true);
    $message.show();
  } else {
    $submit.prop('disabled', false);
    $message.hide();
  }

  return empty.length;
}

$('.wc-box-office-ticket-fields input').on('input change', function () {
  const $inputs = $(this).parents('form').find('input');
  const $submit = $(this).parents('form').find('button[type="submit"]');
  const $message = $(this).parents('form').find('.error-message');

  validateInputs($inputs, $submit, $message);
});

setTimeout(() => {
  handleValidation();
}, 200);

function handleValidation() {
  $('.wc-box-office-ticket-fields').each(function () {
    const $this = $(this);
    const $inputs = $this.find('input');
    const $submit = $this.parents('form').find('button[type="submit"]');
    const $message = $this.parents('form').find('.error-message');

    // Define a function to validate inputs and update the UI
    const validateAndUpdateUI = function () {
      var numberOfEmptyInputs = validateInputs($inputs, $submit, $message);

      if (numberOfEmptyInputs > 0) {
        $this.addClass('error');
      } else {
        $this.removeClass('error');
      }
    };

    // Call on page load
    validateAndUpdateUI();

    // Call on input change
    $inputs.on('input', validateAndUpdateUI);
  });
}

$(document).on('input change keyup paste', '.wc-box-office-ticket-form input', function () {
  const $this = $(this);
  const $inputs = $this.parents('.wc-box-office-ticket-form').find('input');
  const $submit = $this.parents('form').find('button[type="submit"]');
  const $message = $this.parents('form').find('.error-message');

  var numberOfEmptyInputs = validateInputs($inputs, $submit, $message);

  if (numberOfEmptyInputs > 0) {
    $submit.prop('disabled', true);
    $message.show();
  } else {
    $submit.prop('disabled', false);
    $message.hide();
  }
});
